import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { submitPartnerRequest } from "../api/partnerRequestService";

const initialForm = {
  fullName: "",
  phone: "",
  email: "",
  businessName: "",
  city: "",
  message: "",
};

export default function LandingPage() {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const isValid =
    form.fullName.trim().length > 0 && form.phone.trim().length > 0;

  function handleChange(field) {
    return (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isValid || submitting) return;

    setSubmitting(true);
    setError("");
    try {
      await submitPartnerRequest({
        fullName: form.fullName.trim(),
        phone: form.phone.trim(),
        email: form.email.trim() || undefined,
        businessName: form.businessName.trim() || undefined,
        city: form.city.trim() || undefined,
        message: form.message.trim() || undefined,
      });
      setSubmitted(true);
      setForm(initialForm);
    } catch (err) {
      setError(
        typeof err.response?.data === "string"
          ? err.response.data
          : "Something went wrong while sending your request. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Box sx={{ bgcolor: "#f5f6fa", minHeight: "100vh", py: { xs: 6, md: 10 } }}>
      <Container maxWidth="sm">
        <Stack
          alignItems="center"
          spacing={1}
          sx={{ mb: 4, textAlign: "center" }}
        >
          <StorefrontIcon color="primary" sx={{ fontSize: 44 }} />
          <Typography variant="h4" fontWeight={700}>
            Become a Salatty Partner
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Own a business and want to sell on Salatty? Tell us a bit about you
            and we&apos;ll reach out to help you get set up.
          </Typography>
        </Stack>

        <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
          {submitted ? (
            <Alert severity="success" onClose={() => setSubmitted(false)}>
              Thanks for reaching out! Our team will contact you shortly.
            </Alert>
          ) : (
            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                {error && <Alert severity="error">{error}</Alert>}

                <TextField
                  label="Full Name"
                  value={form.fullName}
                  onChange={handleChange("fullName")}
                  required
                  fullWidth
                  autoFocus
                />
                <TextField
                  label="Phone Number"
                  value={form.phone}
                  onChange={handleChange("phone")}
                  required
                  fullWidth
                />
                <TextField
                  label="Email"
                  type="email"
                  value={form.email}
                  onChange={handleChange("email")}
                  fullWidth
                />
                <TextField
                  label="Business Name"
                  value={form.businessName}
                  onChange={handleChange("businessName")}
                  fullWidth
                />
                <TextField
                  label="City"
                  value={form.city}
                  onChange={handleChange("city")}
                  fullWidth
                />
                <TextField
                  label="Tell us about your business"
                  value={form.message}
                  onChange={handleChange("message")}
                  multiline
                  minRows={3}
                  fullWidth
                  helperText="What do you sell, and anything else we should know?"
                />

                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={!isValid || submitting}
                >
                  {submitting ? "Sending..." : "Send Request"}
                </Button>
              </Stack>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
